import {boardUrl, portalHn, portalOther, portalSg} from "../../../config/config";

const Categories = [
	{
		title: 'Gái gọi Hà Nội',
		imageUrl: portalHn,
		url: `${boardUrl}/categories/gai-goi-ha-noi.8/`
	},
	{
		title: 'Gái gọi Sài Gòn',
		imageUrl: portalSg,
		url: `${boardUrl}/categories/gai-goi-sai-gon.19/`
	},
	{
		title: 'Gái gọi TP Khác',
		imageUrl: portalOther,
		url: `${boardUrl}/categories/gai-goi-thanh-pho-khac.32/`
	}
];

const CategorySection = () => {
	return (
		<div className="flex gap-x-2">
			{Categories.map((category, i) => (
				<a key={i} href={category.url} className="block flex-1 relative border-2 border-primary rounded-lg overflow-hidden">
					<div className="w-full h-20 md:h-24 lg:h-48">
						<img src={category.imageUrl} alt={category.title} className="w-full h-full object-cover"/>
					</div>

					<div className="absolute top-0 left-0 w-full h-full bg-black opacity-60 z-10" />

					<div className="absolute bottom-2 left-0 right-0 text-center text-white font-semibold text-sm z-20">
						{category.title}
					</div>
				</a>
			))}
		</div>
	)
}

export default CategorySection;